module.exports = __webpack_public_path__ + "static/media/c1_1.31fa6034.png";